// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3I5G9","errorLogs":"EditorFooter_errorLogs__2wVSo"};